import styles from './Bloc.module.scss';
import Button from '../Button/ButtonComponent';
import { ReactSVG } from 'react-svg';
import { useRouter } from 'next/router';
import { forwardRef } from 'react';
import MoveComponent from '../Move';
import DeleteComponent from '../Delete';
import { dataResources } from '@portal-internet/core';
import { useRedlMetadata } from 'hooks/useRedlMetadata';
import { useRedl } from 'hooks/useRedl';

const { basePath } = dataResources;

const BlocComponent = forwardRef(({ blocIdx, last, children }, ref) => {
    const { setShowRightSidePanel } = useRedl();
    const router = useRouter();
    const { getRedlBlocRawLayout } = useRedlMetadata(router.pathname);
    const blocRawLayout = getRedlBlocRawLayout(blocIdx);

    return (
        <div className={styles.redlBloc} data-testid={`REDL-bloc-${blocIdx}`}>
            <div className={styles.redlBlocInnerButton}>
                <button className={styles.redlBlocButton} ref={ref}>
                    <ReactSVG src={basePath + '/_resources/REDL/icons/three-dots-vertical.svg?v=JIT_ENV_RESOURCES_VERSION'} />
                </button>
            </div>
            <div className={styles.redlBlocInnerBloc}>
                <span className='bloc-snapshot'>
                    <ul className={styles.redlBlocList}>
                        <li className={styles.redlBlocItems}>
                            <MoveComponent blocIdx={blocIdx} last={last} />
                        </li>

                        <li className={styles.redlBlocItems}>
                            <Button variant="edit" size="sm" data-testid={`REDL-edit-button-${blocIdx}`}
                                    onClick={() => setShowRightSidePanel({
                                        size: 'md',
                                        action: 'edit',
                                        blocIdx,
                                        data: blocRawLayout
                                    })}>
                                <ReactSVG src={basePath + '/_resources/REDL/icons/pencil.svg?v=JIT_ENV_RESOURCES_VERSION'} />
                            </Button>
                        </li>

                        <li className={styles.redlBlocItems}>
                            <DeleteComponent blocIdx={blocIdx} />
                        </li>
                    </ul>
                    <div className={styles.redlBlocNumber} data-testid={`REDL-number-${blocIdx}`}>{blocIdx}</div>
                    {children}
                </span>
            </div>
        </div>
    );
});

BlocComponent.displayName = 'BlocComponent';
export default BlocComponent;